import React, { useRef } from "react";
import "./Home.css";
import bgImage from "../Assets/bg.jpg"; 
import Evolve from "../Evolve/Evolve";

import ServiceCard from "../ServiceCard/ServiceCard";
import Client from "../Client/Client";
import Team from "../Team/Team";
import Contact from "../Contact/Contact";
function Home() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div>
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
<div class="overlay"></div>
<svg class="wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
  <path fill="#fff" fill-opacity="1"  d="M0,288L60,272C120,256,240,224,360,213.3C480,203,600,213,720,229.3C840,245,960,267,1080,266.7C1200,267,1320,245,1380,234.7L1440,224L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
</svg>

      <div className="hero-content">
        <div className="hero-title">Do you require BIS Certification for your Product?</div>
        <p>Consult us to get best in class service</p>
        <div className="hero-buttons">
        <a href="tel:+9118008891299">
        <button className="btn primary">
  Talk To Us<br />
  [Toll Free Number]
</button>
          </a>
          <a
    href="https://wa.me/919443407953"
    target="_blank"
    rel="noopener noreferrer"
>
          <button className="btn outline">Connect in WhatsApp</button>
          </a>
          <a href="#contact">
          <button className="btn primary" onClick={scrollToContact}>
  Get in Touch
</button>

          </a>
        </div>
      </div>

<svg
  className="curve"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 1440 320"
  preserveAspectRatio="none"
>
  <path
    fill="#fff"
    fillOpacity="1"
    d="M0,288L60,272C120,256,240,224,360,213.3C480,203,600,213,720,229.3C840,245,960,267,1080,266.7C1200,267,1320,245,1380,234.7L1440,224L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
  ></path>
</svg>


    </section>
    <Evolve/>
<ServiceCard/>
    <Client/>
    <Team/>
<div ref={contactRef}>
  <Contact />
</div>


    </div>
  );
}

export default Home;
